export default __webpack_public_path__ + "static/media/project.dc6afc59.png";